module.exports = __webpack_public_path__ + "assets/img/download_csv.15d8b531.png";